import { renderToStaticMarkup } from 'react-dom/server';
import type { TFunction } from 'i18next';
import SerpContentSnapshot from '@/components/Approval/@components/SerpContentSnapshot';
import { formatSerpText } from '@/utils/approval/serpDocument';
import type { SerpLendingDelaySource } from '@/utils/approval/serpLendingDelay';
import { SerpLendingDelayRoot } from './styles';

type TableProps = {
  source: SerpLendingDelaySource;
  t: TFunction;
};

/** 레거시 #APV_SERP_LENDING_DELAY .form-group 의 표(금액은 응답 글자 그대로) */
const SerpLendingDelayTable = ({ source, t }: TableProps) => (
  <>
    <label className="label font-weight-bold">{t('여신유예 신청')}</label>
    <table className="table table-bordered-horizontal mb-30 text-center">
      <tbody>
        <tr>
          <th className="bg-light">{t('브랜드')}</th>
          <td>{formatSerpText(source.BRAND_NM)}</td>
        </tr>
        <tr>
          <th className="bg-light">{t('매장')}</th>
          <td>{formatSerpText(source.SHOP_ABBR_NM)}</td>
        </tr>
        <tr>
          <th className="bg-light">{t('여신 유예 기간')}</th>
          <td>
            {`${formatSerpText(source.STA_DE)} ~ ${formatSerpText(
              source.END_DE,
            )}`}
          </td>
        </tr>
        <tr>
          <th className="bg-light">{t('여신 유예 금액')}</th>
          <td>{formatSerpText(source.DEF_AMT)}</td>
        </tr>
      </tbody>
    </table>
  </>
);

/** 작성 화면 표 — 저장 content 와 같은 마크업 */
export const SerpLendingDelayTableView = (props: TableProps) => (
  <SerpLendingDelayRoot>
    <div className="form-group">
      <SerpLendingDelayTable {...props} />
    </div>
  </SerpLendingDelayRoot>
);

/** attributes.content — 레거시 조회 화면은 이 HTML 만 그대로 출력 */
export const buildSerpLendingDelayContentHtml = (
  source: SerpLendingDelaySource,
  t: TFunction,
): string =>
  renderToStaticMarkup(
    <div className="form-group">
      <SerpLendingDelayTable source={source} t={t} />
    </div>,
  );

/** 저장 content(레거시 문서 포함) 그대로 */
export const SerpLendingDelaySnapshot = ({ content }: { content: string }) => (
  <SerpLendingDelayRoot>
    <SerpContentSnapshot content={content} />
  </SerpLendingDelayRoot>
);
